/* stylelint-disable */
import * as normalize from 'normalize.css'
import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  ${normalize}
`
